/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Local Imports
*/

import { Input } from './Input';

/**
 * Exports
*/

/**
 * 
 */
export function Radio(props) {
  return <Input type='radio' { ...props } />;
}

Radio.propTypes = {
  name: PropTypes.string.isRequired
};